import { HttpHeaders } from "@angular/common/http";

export interface IHttpRequestOptions {
  url: string;
  headers?: HttpHeaders;
  body?: any;
  disableNotification?: boolean;
  withCredentials?: boolean;
  responseType?: any;
  reportProgress?: boolean;
  observe?: any;
  baseUrl?: string;
  params?: { [key: string]: string };
  /** Passed to HttpClient. `false` skips the SSR transfer cache for this request. */
  transferCache?: boolean;
}
